import { NgModule,CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '../app.material';
import { InsightssliderComponent } from './insightsslider/insightsslider.component';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

import { register } from 'swiper/element/bundle';
import { EventDetailsComponent } from './event-details/event-details.component';
import { ReactiveFormsModule } from '@angular/forms';
import { NotFoundComponent } from './not-found/not-found.component';
import { ConfirmDialogComponent } from './confirm-dialog/confirm-dialog.component';

register();



@NgModule({
  declarations: [ 
    InsightssliderComponent, EventDetailsComponent, NotFoundComponent, ConfirmDialogComponent
  ],schemas:[CUSTOM_ELEMENTS_SCHEMA],
  imports:[ CommonModule,
    MaterialModule,  BrowserModule,
    ReactiveFormsModule ,
    BrowserAnimationsModule,
    FontAwesomeModule],
  exports: [
   
    InsightssliderComponent,
    
   
  ]
})
export class SharedModule { }
